// extracted by mini-css-extract-plugin
export default {"EmailRegister":"MobileAndVerifyForm_EmailRegister__YaQPn"};